import type { ReactNode } from 'react'
import styles from './ConversationHeaderBanner.module.css'

export interface ConversationHeaderBannerProps {
  title: ReactNode
  children: ReactNode
}

/**
 * Conversation Header Banner
 */
export function ConversationHeaderBanner({
  title,
  children,
}: ConversationHeaderBannerProps) {
  return (
    <div className={styles.root}>
      <div className={styles.title}>{title}</div>
      <div className={styles.content}>{children}</div>
    </div>
  )
}
